import type { SubscriptionProduct, AssertProduct } from '@/store/products'

declare const _prd_LWVf3nlME2pf: {
	id: 'prd_LWVf32DEV2nlME2pf'
	ident: 'prd_LWVf3nlME2pf'
	sku: 'simple_premium_12w_23_99_12w_99_usd'
	type: 'subscription'
	phases: [
		{
			type: 'trial'
			interval_unit: 'week'
			interval_duration: 12
			iteration_count: 1
			price_id: 'prc_xNDFb2DEV2mayh0zF'
			amount: 99
			amount_usd: 23.99
			cancellation_fee: null
			currency: 'USD'
			amount_with_discount: 23.99
			discount: 75.01
			promocode: 'BASE'
		},
		{
			type: 'regular'
			interval_unit: 'week'
			interval_duration: 12
			iteration_count: null
			price_id: 'prc_ypAYW2DEV2Vj4R0pB'
			amount: 99
			amount_usd: 99
			cancellation_fee: null
			currency: 'USD'
		},
	]
}
type _check = AssertProduct<typeof _prd_LWVf3nlME2pf, SubscriptionProduct>
const prd_LWVf3nlME2pf = { ident: 'prd_LWVf3nlME2pf' } as typeof _prd_LWVf3nlME2pf

export default prd_LWVf3nlME2pf
